import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import SwitchCommonPopup from "../../../../../components/_utils/CommonPopups/CommonSwitchPopupWithIcon";
import { beneBankLookUp } from "../../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneLookUp,
  resetInEdit,
  viewAccountDetail,
} from "../../../../../redux/features/verifyPAN/verifyPAN";

import ICONS from "../../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import CommonToast from "../../../../../components/_utils/CommonToast";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";

/* We need to call beneficiary account APIs here since after bank account update is
successful, reimbursement account turns into beneficiary account.
*/
function ReimbursementBankEditSucess() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const updatedFields = location?.state?.updatedFields || [];
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
    gstin_no: "",
    contact_no: "",
    email_id: "",
    labels: "",
  });
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [showSwitchAccountModal, setShowSwitchAccountModal] = useState(false);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const { viewAccountDetailData } = useSelector((state) => state.verify);

  const beneLookData = useSelector((state) => state.verify);

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const accountData = viewAccountDetailData?.beneficiary_accounts?.[0];

  useEffect(() => {
    if (accountData) {
      const {
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
        gstin_detail,
        contact_no,
        email_id,
      } = accountData;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
        labels: labels,
        gstin: gstin_detail,
        contact_no,
        email_id: email_id,
      });
    }
  }, [accountData]);

  const createTxn = () => {
    navigate(
      `/beneficiary_transaction_dashboard/create_beneficiary_transaction`,
      {
        state: currentAccountDetails,
      },
    );
  };
  const switchAccountType = () => {
    // dispatch(resetInEdit());
    setShowSwitchAccountModal(true);
  };
  const viewDetailsHandler = () => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
    );
  };

  const dashboardHandler = () => {
    navigate("/beneficiary_account_dashboard");
  };

  const handleChipClick = (id) => {
    setSelectedChipIndex(id);
  };

  useEffect(() => {
    dispatch(viewAccountDetail({ id }));
  }, [id, dispatch]);

  useEffect(() => {
    if (!accountData) return;

    dispatch(beneLookUp({ pan_number: accountData.pan_no }));

    dispatch(
      beneBankLookUp({
        ifsc: accountData.ifsc_code,
        bank_account_no: accountData.bank_acc_no,
      }),
    );
  }, [accountData, dispatch]);

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : ["bank_account_holder_name", "bank_acc_no", "ifsc_code"];

  const bankFieldConfig = {
    // bank_account_holder_name: {
    //   leftSubTitle: "Account name",
    //   getTitle: (acc) => acc?.name,
    // },
    bank_acc_no: {
      leftSubTitle: "Account number",
      getTitle: (acc) => formatAccountNumber(acc?.bank_acc_no),
      ifsc: (acc) => acc?.ifsc_code,
    },
    ifsc_code: {
      leftSubTitle: "IFSC code",
      getTitle: (acc) => acc?.ifsc_code,
    },
  };

  const renderBankCards = () => {
    return fieldsToShow
      .filter((key) => bankFieldConfig[key])
      .map((key) => {
        const config = bankFieldConfig[key];
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: config.getTitle(accountData),
                leftSubTitle: config.leftSubTitle,
                ...(config.ifsc && {
                  ifsc: config.ifsc(accountData),
                }),
              },
            ]}
          />
        );
      });
  };

  const buttonRows = [
    [
      {
        btnText: "Switch account type",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: switchAccountType,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  const chipsArray = [
    {
      text: "Reimbursement account",
      icon: "https://q2pay.in/new_assets/common/home_dashboard_icons/reimbursement_accounts_with_blue_circle.svg",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: false,
      hoverOption: "white",
      bulletPoint: [
        { "Requires below mentioned additional steps": ["User (Optional)"] },
        { "Require approval.": [] },
      ],
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckZero),
    },
    {
      text: "Tax account",
      icon: "https://q2pay.in/new_assets/common/home_dashboard_icons/tax_accounts_with_blue_circle.svg",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: [
        {
          "Requires below mentioned additional steps": [
            "Tax type",
            "Tax section",
          ],
        },
        { "Require approval.": [] },
      ],
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Field force account",
      icon: "https://q2pay.in/new_assets/common/home_dashboard_icons/field_force_accounts_with_blue_circle.svg",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckTwo,
      disabled: false,
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
      bulletPoint: [
        {
          "Requires below mentioned additional steps": [
            "User",
            "Transaction limit",
          ],
        },
        { "Require approval.": [] },
      ],
    },
  ];

  const handleApply = (index) => {
    setShowSwitchAccountModal(false);
    if (index === GlobalConfiguration?.lengthCheckZero) {
      navigate(
        `/reimbursement_account_dashboard/create_reimbursement_account`,
        {
          replace: true,
          state: {
            ...currentAccountDetails,
            type: "switch_account",
          },
        },
      );
    } else {
      CommonToast({
        text: "Feature coming soon",
        icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
        variant: "var(--coming-soon)",
        buttonNeeded: false,
      });
    }
    setSelectedChipIndex(null);
  };

  return (
    <>
      {showSwitchAccountModal && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SwitchCommonPopup
            btnOneHandleFunction={() => {
              setShowSwitchAccountModal(false);
              setSelectedChipIndex(null);
            }}
            headerTitle="Select the type of account you want to switch to:"
            headerFontColor="text-primary"
            headerFontSize="text-md"
            headerFontWeight="semibold"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Next"
            btnTwoHandleFunction={() => {
              handleApply(selectedChipIndex);
            }}
            btnTwoIsDisabled={selectedChipIndex === null}
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            // btnTwoIsLoaderNeeded={handleLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div>
        <StatusContainer
          status="success"
          buttonRows={buttonRows}
          title={
            "Old account archived and new account added to the list of active beneficiary accounts successfully."
          }
        >
          <TabsWeapperSection title="Account details">
            <>{renderBankCards()}</>
          </TabsWeapperSection>
          {beneLookData?.beneLookData?.beneficiary_accounts.length >
            GlobalConfiguration.lengthCheckOne && (
            <TabsWeapperSection title="Accounts Associated to PAN">
              {beneLookData?.beneLookData?.beneficiary_accounts
                ?.filter(
                  (accountData) =>
                    accountData?.approval_status === "pending" ||
                    accountData?.approval_status === "approved",
                )
                .map((accountData, id) => (
                  <InfoCard
                    key={id}
                    bgColor="var(--positive-card)"
                    header={true}
                    borderColor="var(--positive-bg)"
                    rightHeaderText={`${
                      accountData?.approval_status?.charAt(0).toUpperCase() +
                      accountData?.approval_status?.slice(1)
                    } account`}
                    rightHeaderTextColor="var(--text-secondary)"
                    leftHeaderText={accountData?.bank_account_holder_full_name
                      ?.toLowerCase()
                      ?.split(" ")
                      ?.map(
                        (word) =>
                          word
                            .charAt(GlobalConfiguration?.lengthCheckZero)
                            .toUpperCase() +
                          word.slice(GlobalConfiguration?.lengthCheckOne),
                      )
                      ?.join(" ")}
                    leftHeaderWidth="w-width-lg"
                    rows={[
                      {
                        leftTitle: accountData?.bank_acc_no,
                        leftSubTitle: "Bank account number",
                        ifsc: accountData?.ifsc_code,
                      },
                    ]}
                  />
                ))}
            </TabsWeapperSection>
          )}

          {benebankLookData?.beneficiary_accounts?.length >
            GlobalConfiguration.lengthCheckOne && (
            <TabsWeapperSection title="Accounts Associated to Bank">
              {benebankLookData?.beneficiary_accounts
                .filter(
                  (accountData) =>
                    accountData?.approval_status === "pending" ||
                    accountData?.approval_status === "approved",
                )
                .map((accountData, id) => (
                  <InfoCard
                    key={id}
                    bgColor="var(--positive-card)"
                    header={true}
                    borderColor="var(--positive-bg)"
                    rightHeaderText={`${
                      accountData?.approval_status?.charAt(0).toUpperCase() +
                      accountData?.approval_status?.slice(1)
                    } account`}
                    rightHeaderTextColor="var(--text-secondary)"
                    leftHeaderText={accountData?.name}
                    leftHeaderWidth="w-width-lg"
                    rows={[
                      {
                        leftTitle: accountData?.pan_no,
                        leftSubTitle: "PAN number",
                      },
                    ]}
                  />
                ))}
            </TabsWeapperSection>
          )}
        </StatusContainer>
      </div>
    </>
  );
}

export default ReimbursementBankEditSucess;
